// import React from "react";
// import { motion } from "framer-motion";

// const LogoLoader = () => {
//   const rotationTime = 0.4;
//   const stopTime = 0.4;
//   const totalTime = (rotationTime + stopTime) * 4;

//   return (
//     <motion.div
//       className="grid grid-cols-2 w-fit rounded overflow-hidden"
//       initial={{ rotate: 0 }}
//       animate={{
//         rotate: [0, 90, 90, 180, 180, 270, 270, 360, 360],
//         gap: ["0.25rem", "0rem"],
//       }}
//       transition={{
//         rotate: {
//           duration: totalTime,
//           times: [0, 0.05, 0.25, 0.3, 0.5, 0.55, 0.75, 0.8, 1],
//           repeat: Infinity,
//           repeatType: "loop",
//           ease: "linear",
//         },
//         gap: {
//           duration: stopTime,
//           repeat: Infinity,
//           repeatType: "mirror",
//           ease: "easeIn",
//         },
//         borderRadius: {
//           duration: stopTime,
//           repeat: Infinity,
//           repeatType: "mirror",
//           ease: "easeIn",
//         },
//       }}
//       style={{
//         display: "grid",
//         gridTemplateColumns: "repeat(2, 1fr)",
//       }}
//     >
//       <motion.div
//         className="w-5 h-5 bg-primary"
//         animate={{ borderRadius: ["0.25rem", "0rem"] }}
//         transition={{
//           duration: stopTime,
//           repeat: Infinity,
//           repeatType: "mirror",
//           ease: "easeIn",
//         }}
//         dataId="1"
//       />
//       <motion.div
//         className="w-5 h-5 bg-black"
//         animate={{ borderRadius: ["0.25rem", "0rem"] }}
//         transition={{
//           duration: stopTime,
//           repeat: Infinity,
//           repeatType: "mirror",
//           ease: "easeIn",
//         }}
//         dataId="2"
//       />
//       <motion.div
//         className="w-5 h-5 bg-black"
//         animate={{ borderRadius: ["0.25rem", "0rem"] }}
//         transition={{
//           duration: stopTime,
//           repeat: Infinity,
//           repeatType: "mirror",
//           ease: "easeIn",
//         }}
//         dataId="3"
//       />
//       <motion.div
//         className="w-5 h-5 bg-primary"
//         animate={{ borderRadius: ["0.25rem", "0rem"] }}
//         transition={{
//           duration: stopTime,
//           repeat: Infinity,
//           repeatType: "mirror",
//           ease: "easeIn",
//         }}
//         dataId="4"
//       />
//     </motion.div>
//   );
// };

// export default LogoLoader;

import React from "react";
import { motion } from "framer-motion";

const LogoLoader = () => {
  const rotationTime = 0.4;
  const stopTime = 0.4;
  const totalTime = (rotationTime + stopTime) * 4;

  const squareConfig = {
    animate: { borderRadius: ["0.25rem", "0rem"] },
    transition: {
      duration: stopTime,
      repeat: Infinity,
      repeatType: "mirror",
      ease: "easeIn",
    },
  };

  const squares = [
    { bg: "bg-primary", id: "1" },
    { bg: "bg-black", id: "2" },
    { bg: "bg-black", id: "3" },
    { bg: "bg-primary", id: "4" },
  ];

  return (
    <motion.div
      className="grid grid-cols-2 w-fit rounded overflow-hidden"
      initial={{ rotate: 0 }}
      animate={{
        rotate: [0, 90, 90, 180, 180, 270, 270, 360, 360],
        gap: ["0.25rem", "0rem"],
      }}
      transition={{
        rotate: {
          duration: totalTime,
          times: [0, 0.05, 0.25, 0.3, 0.5, 0.55, 0.75, 0.8, 1],
          repeat: Infinity,
          repeatType: "loop",
          ease: "linear",
        },
        gap: {
          duration: stopTime,
          repeat: Infinity,
          repeatType: "mirror",
          ease: "easeIn",
        },
        borderRadius: {
          duration: stopTime,
          repeat: Infinity,
          repeatType: "mirror",
          ease: "easeIn",
        },
      }}
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
      }}
    >
      {squares.map(({ bg, id }) => (
        <motion.div
          key={id}
          className={`w-5 h-5 ${bg}`}
          {...squareConfig}
          data-id={id}
        />
      ))}
    </motion.div>
  );
};

export default LogoLoader;
